
import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
    Container,
    Box,
    Heading,
    Text,
    Button,
    Spinner,
    useToast,
    useColorModeValue,
} from '@chakra-ui/react'
import axiosInstance from "../../../api/axiosInstance";
import { useTranslation } from 'react-i18next'

export default function AcceptAccount() {
    const { t } = useTranslation()
    const tr = (key, defaultValue) => t(key, { defaultValue })
    const { token } = useParams()
    const [status, setStatus] = useState('loading')
    const [message, setMessage] = useState('')
    const toast = useToast()
    const navigate = useNavigate()
    const cardBg = useColorModeValue('white', 'navy.800')

    useEffect(() => {
        const accept = async () => {
            try {
                const { data } = await axiosInstance.post('/accounts/accept', { token })
                setStatus('success')
                setMessage(data.message)
                toast({ title: 'Linked!', description: data.message, status: 'success', duration: 3000 })
                navigate('/admin/default')
            } catch (err) {
                setStatus('error')
                const errMsg = err.response?.data?.error || 'Failed to accept invite'
                setMessage(errMsg)
            }
        }
        accept()
    }, [token, toast])

    return (
        <Container centerContent py={20}>
            <Box textAlign="center" p={8} bg={cardBg} borderRadius="md" shadow="md">
                {status === 'loading' && <Spinner size="xl" mb={4} />}
                {status === 'success' && (
                    <>
                        <Heading size="md" mb={2}>
                            {tr('acceptLink.success', 'Success!')}
                        </Heading>
                        <Text mb={4}>{message}</Text>
                        <Button colorScheme="blue" onClick={() => navigate('/admin')}>
                            {tr('acceptLink.goDashboard', 'Go to Dashboard')}
                        </Button>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <Heading size="md" mb={2} color="red.500">
                            {tr('acceptLink.oops', 'Oops!')}
                        </Heading>
                        <Text mb={4}>{message}</Text>
                        <Button onClick={() => navigate('/')}>{tr('acceptLink.home', 'Home')}</Button>
                    </>
                )}
            </Box>
        </Container>
    )
}
